module.exports = __webpack_public_path__ + "img/logo_top.577a3bd5.png";